import { defineStore } from 'pinia';

export interface IClassCreationState {
  hasCreatedClass: boolean;
  navigateAfterCreation: boolean;
  tooltipSeen: boolean;
}

export const useClassCreationStore = defineStore('classCreation', {
  state: (): IClassCreationState => ({
    hasCreatedClass: false,
    navigateAfterCreation: true,
    tooltipSeen: false,
  }),

  actions: {
    setClassCreated() {
      this.hasCreatedClass = true;
    },
    resetClassCreated() {
      this.hasCreatedClass = false;
    },
    setTooltipSeen() {
      this.tooltipSeen = true;
    },
  },
  persist: {
    key: 'class-creation-store',
    storage: localStorage,
  },
});
